import api from '@/api/index.js'

const account_cap_limit = {
  state: {
    loading: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_CAP_LIMIT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_CAP_LIMIT: (state, response) => {

      if (response && response.caps) {
        response.caps.sort((a, b) =>
          a.fare_group_id.toLowerCase().localeCompare(b.fare_group_id.toLowerCase())
        );
      }
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_CAP_LIMIT_ERROR: (state, error) => {
      state.error = error;
    },
  },

  actions: {
    GetAccountCapLimit({commit}, req) {
      commit('SET_ACCOUNT_CAP_LIMIT', null)
      commit('SET_ACCOUNT_CAP_LIMIT_ERROR', null)
      commit('SET_ACCOUNT_CAP_LIMIT_LOADING', true)
      return api.get(`accounts/${req.accountId}/cap-limit?capName=calendar_month`)
        .then((response) => {
          commit('SET_ACCOUNT_CAP_LIMIT', response)
          commit('SET_ACCOUNT_CAP_LIMIT_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_CAP_LIMIT_ERROR', error)
          commit('SET_ACCOUNT_CAP_LIMIT_LOADING', false)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_cap_limit
